import React, { FC, useContext, useState } from 'react';
import {
  DataLayerContext,
  DataLayerContextType,
} from '../../providers/data-layer/data-layer.provider';
import GtmEventNameEnum from '../../../models/gtm-event-name-enum';
import { ProductDetailResultType } from '../../../models/product-detail-result-type';
import { ProductDetailResultVariantType } from '../../../models/product-detail-result-variant-type';
import { ProductDetailsType } from '../../../models/product-details-type';
import ProductTypeEnum from '../../../models/product-type-enum';
import ProductDownloadButton from '../../atoms/product-download-button/product-download-button';

interface Props extends ProductDetailsType, ProductDetailResultType {}

const ProductAttributes: FC<Props> = ({
  attributes,
  labels,
  product,
}: Props) => {
  const { pushToDataLayer } =
    useContext<DataLayerContextType>(DataLayerContext);

  const [expanded, setExpanded] = useState<boolean>(false);
  const pushProductToDataLayer = (event: GtmEventNameEnum) =>
    pushToDataLayer(event, {
      featuredProduct: product.properties.featuredProduct === '1',
      productType: ProductTypeEnum.Website,
    });

  return (
    <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-12">
      <div className="flex flex-col space-y-4 w-full md:w-6/12 ">
        <h4 className="page-heading-four">
          {labels.specificationSectionHeading}
        </h4>

        {product.shortDescription && (
          <p className="text-grey-600">{product.shortDescription}</p>
        )}
        {product.longDescription && (
          <div
            className={`relative overflow-hidden ${expanded ? '' : 'h-20'} `}
          >
            <p className="text-grey-600 ">{product.longDescription}</p>

            <div
              style={{
                background: expanded
                  ? 'transparent'
                  : 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
              }}
              className="absolute bottom-0 left-0 w-full h-20 "
            />
          </div>
        )}
        <span
          style={{
            marginTop: 0,
            paddingTop: 17,
          }}
        >
          <button
            type="button"
            className="underline text-french-blue hover:cursor-pointer"
            onClick={() => setExpanded(!expanded)}
          >
            Show {expanded ? 'less' : 'more'}
          </button>
        </span>
      </div>

      {product.properties.techData && (
        <div className="flex flex-col space-y-1 w-full md:w-6/12">
          <h4 className="page-heading-four">{labels.detailsSectionHeading}</h4>
          <table className="table-fixed w-full">
            <tbody>
              {attributes.map((attribute: ProductDetailResultVariantType) => (
                <tr key={attribute.key} className="border-b border-grey-100">
                  <td className="text-grey-600 py-3">{attribute.name}</td>

                  <td className="py-3">{attribute.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <h4 className="page-heading-four pt-9 mb-3">
            {labels.downloadsSectionHeading}
          </h4>

          <h6
            style={{ fontWeight: 400 }}
            className="page-heading-six mb-3 text-grey-600"
          >
            {labels.technicalDataSheetsSectionHeading}
          </h6>

          <ProductDownloadButton
            label={product.properties.techData.substring(
              product.properties.techData.lastIndexOf('/') + 1,
              product.properties.techData.length
            )}
            onClick={() =>
              pushProductToDataLayer(GtmEventNameEnum.ProductDownloadTechsheet)
            }
            url={product.properties.techData}
          />

          {/* TODO: FLOFEB-19 Re-introduce when available in PIM
            <h6 className="page-heading-six mt-6 mb-3 text-grey-600">
              {labels.computerAidedDrawingSectionHeading}
            </h6>

            <ProductDownloadButton
              label="Test"
              onClick={() =>
                pushProductToDataLayer(GtmEventNameEnum.ProductDownloadCad)
              }
              url="/todo"
            />

            <ProductDownloadButton
              label="Test"
              onClick={() =>
                pushProductToDataLayer(GtmEventNameEnum.ProductDownloadCad)
              }
              url="/todo"
            /> */}
        </div>
      )}
    </div>
  );
};

export default ProductAttributes;
